import { LinkProps } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import ListItemButton, { ListItemButtonProps } from '@mui/material/ListItemButton';
import { Classnames } from '@cbridge-utils/mui-theme';
import { NavigationItemHorizontalPadding, NavigationItemVerticalPadding } from '../NavigationItem.interface';
import { INavigationListItemButtonProps } from './NavigationListItemButton.interface';

export const NavigationListItemButton = styled(
  ({
    isActionAlwaysVisible,
    depth = 0,
    py = NavigationItemVerticalPadding.lg,
    px = NavigationItemHorizontalPadding.lg,
    ...props
  }: INavigationListItemButtonProps) => (
    <ListItemButton
      {...props}
      sx={{
        pl: px + px * depth,
        pr: px,
        py,
      }}
    />
  ),
)<ListItemButtonProps | LinkProps>(({ theme, isActionAlwaysVisible }) => ({
  ...(!isActionAlwaysVisible && {
    '&:hover': {
      [`& .${Classnames.VISIBLE_ON_HOVER}`]: {
        opacity: 1,
        transition: 'opacity 0.3s linear',
      },
    },
    [`& .${Classnames.VISIBLE_ON_HOVER}`]: {
      opacity: 0,
    },
  }),
  '&.Mui-selected': {
    '& .MuiListItemIcon-root': {
      color: (theme.vars ?? theme).palette.primary.main,
    },
    '& .MuiTypography-root': {
      color: (theme.vars ?? theme).palette.text.primary,
    },
    '& .MuiTouchRipple-child': {
      backgroundColor: (theme.vars ?? theme).palette.primary.main,
    },
  },
  '& .MuiAvatar-root': {
    backgroundColor: (theme.vars ?? theme).palette.action.active,
  },
}));
